module.exports = __webpack_public_path__ + "static/media/calendarIcon.6b960b0e.svg";